import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import { ProtectedRoute } from './ProtectedRoute';
import { AdminRoute } from './AdminRoute';
import QuinielaList from '../components/quinielas/QuinielaList';
import ManageMatches from '../components/admin/ManageMatches';
import ManageResults from '../components/admin/ManageResults';
import AdminLayout from '../components/admin/AdminLayout';
import Rankings from '../components/Rankings';
import CapturedResults from '../components/quinielas/CapturedResults';
import ViewQuinielas from '../components/admin/ViewQuinielas';
import { useAuth } from '../context/AuthContext';
import { useLeague } from '../context/LeagueContext';
import ActivarQuinielas from '../components/admin/ActivarQuinielas';
import ManageUsers from '../components/admin/ManageUsers';
import ManagePredictions from '../components/admin/ManagePredictions';
import ResetMatchPredictions from '../components/admin/ResetMatchPredictions';
import ProfilePage from '../pages/ProfilePage';
import LeagueSelectionPage from '../pages/LeagueSelectionPage';
import { MundialPage } from '../pages/MundialPage';
import { AdminMundialPage } from '../pages/admin/AdminMundialPage';
import { ReglamentoPage } from '../pages/ReglamentoPage';

const AppRoutes: React.FC = () => {
  const { user } = useAuth();
  const { league } = useLeague();

  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/olvide-contrasena" element={<ForgotPasswordPage />} />
      <Route path="/rankings" element={<Rankings />} />
      <Route path="/reglamento" element={<ReglamentoPage />} />

      {/* Selección de liga: solo para usuarios logueados */}
      <Route path="/select-league" element={user ? <LeagueSelectionPage /> : <Navigate to="/login" replace />} />

      {/* Rutas protegidas: requieren login Y liga seleccionada */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={league ? <HomePage /> : <Navigate to="/select-league" replace />} />
        <Route path="/quinielas" element={league ? <QuinielaList /> : <Navigate to="/select-league" replace />} />
        <Route
          path="/mundial"
          element={
            league === 'mundial_fifa' ? (
              <MundialPage />
            ) : (
              <Navigate to={league ? '/' : '/select-league'} replace />
            )
          }
        />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>

      {/* Rutas de administrador */}
      <Route element={<AdminRoute />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="matches" element={<ManageMatches />} />
          <Route path="results" element={<ManageResults />} />
          <Route path="activar-quinielas" element={<ActivarQuinielas />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="predictions" element={<ManagePredictions />} />
          <Route path="reset-predictions" element={<ResetMatchPredictions />} />
          <Route path="mundial" element={<AdminMundialPage />} />
        </Route>
      </Route>

      {/* Agregar nueva ruta */}
      <Route path="/quiniela/quinielas-capturadas" element={<CapturedResults />} />

      {/* Ruta por defecto */}
      <Route path="*" element={<Navigate to="/" replace />} />

      <Route
        path="/admin/ver-quinielas"
        element={
          user && user.email === 'htorres@teiker.mx'
            ? <ViewQuinielas />
            : <Navigate to="/" />
        }
      />
    </Routes>
  );
};

export default AppRoutes; 